<template>
  <div @load="loadImage">
    <div class="gameplay_title_container">

      <div class="gameplay_title">
        {{ gameInfo.question }}
      </div>
    </div>

    <div  class="gameplay_game_box_list gameplay_tap_box memory6">
      <div class="gameplay_btns_col">
        <button :disabled="buttonPushed"
                :style="!buttonPushed ? 'cursor:pointer' : 'pointer-events:none'"
                v-for="(answer, index) in gameInfo.questions" @click="sendAnswer(index)"
                :key="answer.answerKey" type="button"
                :class=buttonCss(index)>
          {{answer}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import { gameplayFooter } from '@/common/jQuery';

export default {
  name: 'MemoryAttentionList',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin2],
  data() {
    return {
      gameInfo: null,
      timeToViewTheList: null,
      buttonPushed: false,
      registeredAnswer: null,
      userAnswerCorrect: null,
    };
  },
  created() {
    console.log('in Game created hook');
    this.initGameData();
    this.timeToViewTheList = false;
    console.log(this.timeToViewTheList);
  },
  mounted() {
    this.$nextTick(() => {
      this.loadImage();
    });
  },
  updated() {
    this.loadImage();
  },
  methods: {
    ...mapMutations('game', [
      'resetGameState',
    ]),
    buttonCss(index) {
      if (this.registeredAnswer === index && this.userAnswerCorrect) {
        return 'gameplay_btn select_answer gameplay_btn_correct';
      } else if (this.registeredAnswer === index && !this.userAnswerCorrect) {
        return 'gameplay_btn select_answer gameplay_btn_false';
      }
      return 'gameplay_btn select_answer';
    },
    loadImage() {
      gameplayFooter();
    },
    initGameData() {
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
      console.log(this.gameInfo);
    },
    getTheFinalList() {
      setTimeout(() => {
        console.log('image');
      }, 3000);
      console.log('image');
      this.timeToViewTheList = true;
    },
    changeQuestionText() {
      if (this.timeToViewTheList === true) {
        return this.gameInfo.question;
      }
      this.getTheFinalList();
      return 'Watch the image carefully You will answer a question.';
    },
    calculateRefIndex(indexToBack) {
      return this.$refs[indexToBack];
    },
    sendAnswer(index) {
      const indexToBack = index;
      let isCorrectAnswer = false;
      if (this.buttonPushed) {
        console.log('--> User 2 times. Wait for Answer....');
      } else {
        this.buttonPushed = true;
        this.$axios({
          url: `api/sendAnswerBrainiac?gameId=${this.gameID}&miniGameId=${this.gameInfo.id}&answerIndex=${indexToBack}`,
          method: 'GET',
          headers: {
            Authorization: this.jwtInVuex,
          },
        }).then((response) => {
          const responseData = response.data.data;
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            this.registeredAnswer = index;
            if (responseData.status === 'WRONG_ANSWER') {
              this.userAnswerCorrect = false;
            } else if (responseData.status === 'CORRECT_ANSWER') {
              isCorrectAnswer = true;
              this.userAnswerCorrect = true;
            }
          }
          console.log('wait 1,5 secs for response and go to next game');
          setTimeout(() => {
            console.log('Go to next game');
            this.normalTransition = true;
            this.storeBrainiacGameData(isCorrectAnswer);
            this.initGameData();
          }, 1500);
        }).catch((error) => {
          console.log(`Invoking api/sendAnswer failed with the following error: ${error}`);
        });
      }
    },

  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'gameID',
      'gameType',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/memory/MemoryAttentionList.vue